// extracted by mini-css-extract-plugin
export var card = "_8s-1";
export var container = "_8s-0";